export const LANGUAGES = [
  'English',
  'French',
  'German',
  'Spanish',
  'Portuguese',
  'Italian',
  'Dutch',
  'Japanese',
  'Russian',
  'Arabic',
  'Greek',
  'Swedish',
  'Farsi / Persian / Language of Iran',
  'Indonesian',
  'Mandarin',
  'Korean',
  'Danish',
  'Turkish',
  'Thai',
  'Macedonian',
  'Hebrew',
  'Polish',
  'Norwegian',
  'Serbo-Croatian',
  'Flemish',
  'Hungarian',
  'Romanian',
  'Dari',
  'Swahili',
  'Hindi',
  'Afrikaans',
  'Vietnamese',
  'Catalan',
  'Icelandic',
  'Finnish',
  'Ilocano',
  'Ukrainian',
  'Tagalog',
  'Maori',
  'Bengali',
  'Czech',
  'Cantonese',
  'Panopean',
  'Latin',
  'Armenian',
  'Malay',
  'Samoan',
  'Wolof',
  'Gujarati',
  'Kinyarwanda',
  'Occitan',
  'Slovak',
  'Welsh',
  'Pashto, Pushto',
  'Urdu',
  'Navaho',
  'Lao',
  'Bulgarian',
  'Lithuanian',
  'Hausa',
  'Creole / Haitian',
  'Efik',
  'Punjabi',
  'Nepali',
  'Kurdish',
  'Tamil',
  'Amharic',
  'Telugu',
  'Cambodian',
  'Basque',
  'Slovenian',
  'British',
  'Cebuano',
  'Burmese',
  'Tajik',
  'Yuanese',
  'Irish Gaelic',
  'Scots Gaelic',
  'Ossetian',
  'BWL',
  'Sonstige',
  'Sinhalese',
  'Latvian (Lettish)',
  'Serbian',
  'Croatian',
  'Baluchi',
  'Shanghainese',
  'Albanian',
  'Somali',
  'Brazilian Portuguese',
  'Kannada',
  'Luxembourgish',
  'Swiss German',
]

const SPECIALIZATIONS = [
  'Advanced Writing',
  'Grammar',
  'Business',
  'Banking/Finance',
  'Technical',
  'Presentations',
  'Negotiating',
  'Exam Preparation',
  'Social Situations',
  'Meetings and Presentations',
  'Accounting/Controlling',
  'Automotive Industry',
  'Customer Care',
  'Energy Industry',
  'Food Industry',
  'Human Resources',
  'Insurance',
  'IT',
  'Legal',
  'Logistics',
  'Marketing',
  'Medical/Health Industry',
  'Office',
  'Pharmaceutical Industry',
  'Purchasing',
  'Real Estate',
  'Sales',
  'Telecommunication',
  'Customised',
  'Pronunciation',
  'Native-language Tutoring',
  'Engineering',
]

export const convertToOptions = (data: string[]) =>
  data.map((item, i) => ({ id: i.toString(), label: item, value: item }))

export const FILTERS = {
  LANGUAGES: convertToOptions(LANGUAGES),
  SPECIALIZATIONS: convertToOptions(SPECIALIZATIONS),
}
